/**
 * Process string to number with unit
 * @param {String} input
 * @param {PropertyValueProps} map
 */
const processNumber = (input, map) => {
  if (/\d$/.test(input)) {
    map.set("is-number", true);
    map.set("value", Number(input));

    return map;
  } else {
    const number = /^(\.|\d)+(\.\d+)?/.exec(input);

    const string = number?.[0] || "";
    const value = Number(string);
    const unit = input.replace(string, "");

    map.set("is-number", true);
    map.set("value", value);
    map.set("unit", unit);

    return map;
  }
};

export default processNumber;
